import { yupResolver } from '@hookform/resolvers/yup';
import { array, date } from 'yup';

import { FrequencyTypes } from 'enums/types';

import {
  object, string, boolean, REQUIRED_MESSAGE,
} from './general';

const schema = object().shape({
  active: boolean().required(REQUIRED_MESSAGE),
  client: object().shape({
    code: string().required(REQUIRED_MESSAGE),
    name: string().required(REQUIRED_MESSAGE),
    contractCompany: object().shape({
      id: string().required(REQUIRED_MESSAGE),
      label: string().required(REQUIRED_MESSAGE),
    }),
    costumer: object().shape({
      id: string().required(REQUIRED_MESSAGE),
      label: string().required(REQUIRED_MESSAGE),
    }),
    project: object().shape({
      id: string().required(REQUIRED_MESSAGE),
      label: string().required(REQUIRED_MESSAGE),
    }),
    regional: object().shape({
      id: string().required(REQUIRED_MESSAGE),
      label: string().required(REQUIRED_MESSAGE),
    }),
  }),
  frequency: string().required(REQUIRED_MESSAGE),
  day: array().when('frequency', (frequency) => {
    if (frequency === FrequencyTypes.Weekly) {
      return array().of(boolean()).test('day', 'Escolha pelo menos um dia', (value) => value.some((v) => v));
    }
    return undefined;
  }),
  info: object().shape({
    startDate: date().required(REQUIRED_MESSAGE),
    maxOverdue: string().optional(),
    routeCents: string().optional(),
    excessKmCents: string().optional(),
    dailyKm: string().required(REQUIRED_MESSAGE),
    monthlyKm: string().required(REQUIRED_MESSAGE),
    source: string().required(REQUIRED_MESSAGE),
    destination: string().required(REQUIRED_MESSAGE),
  }).required(REQUIRED_MESSAGE),
});

export default yupResolver(schema);
